<template>
  <div>
    <!-- Aktivator-Button -->
    <v-dialog persistent class="rounded-lg" v-model="dialog" max-width="520px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-show="loaded && (!existingFeedback || !existingFeedback.length)"
          color="primary"
          class="mx-auto"
          @click="setNavigationbarVisibility(false)"
          dark
          v-bind="attrs"
          v-on="on">
          Gib uns dein Feedback
        </v-btn>
      </template>

      <!-- Dialog mit halbtransparentem Hintergrund -->
      <v-card class="feedback-card">
        <v-card-title class="headline"> DEINE MEINUNG ZÄHLT! </v-card-title>

        <v-card-text>
          <!-- Einleitung -->
          <p>Bitte nimm dir doch einen Moment Zeit und bewerte uns.</p>

          <!-- Rating Betreuung -->
          <div class="my-4">
            <p>Wie zufrieden bist du mit unserer Betreuung?</p>
            <v-rating v-model="assistance" length="5" background-color="grey lighten-2" color="amber" large />
          </div>

          <!-- Rating Ausstattung -->
          <div class="my-4">
            <p>Wie zufrieden bist du mit der Ausstattung des Centers?</p>
            <v-rating v-model="equipment" length="5" background-color="grey lighten-2" color="amber" large />
          </div>

          <!-- Freitext-Feedback -->
          <v-textarea v-model="textFeedback" label="Gibt es noch etwas, das du uns sagen möchtest?" rows="4" auto-grow />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="close">Abbrechen</v-btn>
          <v-btn color="primary" :disabled="!canSubmit" @click="submit"> Jetzt absenden </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import api from "@/api"

export default {
  name: "FeedbackDialog",
  data() {
    return {
      existingFeedback: null,
      dialog: false,
      assistance: 0,
      equipment: 0,
      textFeedback: "",
      loaded: false,
    }
  },
  computed: {
    // Mindestens je 1 Stern nötig, um absenden zu aktivieren
    canSubmit() {
      return this.assistance >= 1 && this.equipment >= 1
    },
  },
  async created() {
    this.existingFeedback = await api.getExistingGoogleFeedback()

    this.loaded = true
    this.$forceUpdate()
    console.log(this.loaded, this.existingFeedback, this.loaded && (!this.existingFeedback || !this.existingFeedback.length))
  },
  methods: {
    ...mapActions("navigationStoreNotPersisted", ["setNavigationbarVisibility"]),

    close() {
      this.dialog = false
      this.setNavigationbarVisibility(true)
      this.resetForm()
    },
    async submit() {
      const payload = {
        assistance: this.assistance,
        equipment: this.equipment,
        feedback: this.textFeedback,
      }

      let createdData = await api.sendNewGoogleFeedback(payload)
      // Extra-Frage bei Top-Bewertungen
      if (this.assistance >= 4 && this.equipment >= 4) {
        const goToGoogle = window.confirm("Danke für dein Feedback! Über deine Bewertung auf google würden wir uns sehr freuen:")
        if (goToGoogle) {
          window.open(
            "https://www.google.com/search?sca_esv=6d4f6f4c4203e97c&sxsrf=AHTn8zq11IfPhzDsF6cfILPATq_QmQjpiA:1747031660073&si=APYL9btvhO6SAb8jF9HqTZMMa7vs_teLnZaEVrJZwRKFIIKjoZ4aZ9N-2H9DYNEOaIz-GlWvCWBCR81VecNPA-Pco4aZoxUXiWJs5OKq4RU_AsJ3Q2uqnf41mEZYZR4trkftp6s7e5UtmHJ75ROe22CcIM7s7URfFA%3D%3D&q=well+come+Fit+AG+B%C3%BClach+Rezensionen&sa=X&ved=2ahUKEwjMi4qMqJ2NAxXXyAIHHT0gJgMQ0bkNegQIJhAE&biw=1912&bih=968&dpr=1#lrd=0x479075cc7f791587:0xfe51b961a14ca1db,3,,,,",
            "_blank"
          )
        }
      }
      this.$toast.success("Danke für din Feedback!")
      this.loaded = false
      this.close()
    },
    resetForm() {
      this.assistance = 0
      this.equipment = 0
      this.textFeedback = ""
    },
  },
}
</script>

<style scoped>
.feedback-card {
  background-color: rgba(245, 245, 245, 0.95); /* hellgrau, leicht transparent */
}
/* Abstände für die Absätze */
.my-4 {
  margin-top: 16px;
  margin-bottom: 16px;
}
</style>
